/**
 * Funkcja pozwalajaca na sortowanie tablic zawierajacych
 * np. obiekty po kluczu obiektu,
 * (według testów znacznie wydajniejsza od 'localeCompare').
 * @param {Array} array tablica do posortowania,
 * @param {String} key klucz obiektu po którym maja być sortowane obiekty w tablicy,
 * @param {String | string[]} locales kody krajów 'Intl.Collator - locales',
 * @param {Object} options - opcje 'Intl.Collator - options'
 */
export default (array, key=null, locales=undefined, options={}) => {
    const collator = new Intl.Collator(locales, {
        numeric: false,
        sensitivity: 'base',
        ...options
      });
      
      if (key) {
        return array.sort((a, b) => collator.compare(a[key], b[key]));
      }

      return array.sort((a, b) => collator.compare(a, b));
}